import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { PlaylistService } from 'src/app/core/services/playlist.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { PrivateLibraryPackageService } from 'src/app/core/services/private-library-package.service';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-select-audio-playlist-items-modal',
  templateUrl: './select-audio-playlist-items-modal.component.html',
  styleUrls: ['./select-audio-playlist-items-modal.component.scss']
})
export class SelectAudioPlaylistItemsModalComponent implements OnInit, OnChanges {

  @Input() name;
  @Input() string;
  @Input() data;
  @Input() musicDataPlaylist;
  @Input() videoDataPlaylist;
  @Input() flagAdd;
  @Input() playlistToggleId;
  @Input() editPlaylistObj;
  @Input() contentIds;
  @Input() disable;

  music = [];
  video = [];
  submitted: boolean = false;
  playlistName: FormGroup;
  playListData: any;
  isError: boolean = false;
  errorMessage: string;
  playList = [];
  playListSelectFlag = false;
  collectablesAttributes = [];
  searchText: string = '';
  imagePath: string;
  playlistObj = {};
  selectedPlaylistAudio = null;
  selectedPlaylistVideo = null;
  selectedPlaylistDetail: boolean = false;
  addSongs = [];
  addVideos = [];
  contentPlaylistSelect = [];
  SelectedPlaylistArray = [];
  isPlayListError = false;
  isLoading = false;
  isAddContentPlaylist = false;
  currentUser;
  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private _playListService: PlaylistService,
    private _spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private _privateLibraryPackageService: PrivateLibraryPackageService,
    private _authService: AuthService
  ) { }

  ngOnInit() {
    this.currentUser = this._authService.getCurrentUser();
    // console.log(this.editPlaylistObj);
    if (this.editPlaylistObj) {
      this.name = this.editPlaylistObj.name;
    }
    this.imagePath = environment.url;
    this.getAudioContentPlaylist();
    // this.addAudioVideo();
    // this.playlistName = this.name;
    this.playlistName = this.formBuilder.group({
      name: [this.name, [Validators.required, Validators.pattern('^(?=.*?[a-zA-Z]).+$'), Validators.maxLength(30)]],
    })
  }

  ngOnChanges() {
  }

  closeDialog() {
    this.activeModal.close();
  }

  getAudioContentPlaylist() {
    // if (!this.flagAdd) {

    this._spinner.show();
    const obj = {
      category_type: 'all',
      library_type: 'public',
    }

    let param = '';
    if (this.currentUser.user.id) {
      param += `?user_id=${this.currentUser.user.id}&for=${this.data}`;
    }
    if (this.playlistToggleId && this.flagAdd && this.contentIds.length) {
      param += '&removable_content_ids=' + this.contentIds.join(',');
    }
    this.isLoading = true;
    this._playListService.getAudioContentPlaylistPublic(param).subscribe((response: any) => {
      this.isLoading = false;
      if (response.success) {
        if (this.data === 'audio') {
          this.playList = response.data.audio;
          this.playList.map(music => {
            music.isSelected = false;
            music.thumb = (music.thumb != '') ? this.imagePath + music.thumb : '../../assets/images/icons/audio-primary-default-card-icon.jpg';
          });
        }
        else if (this.data === 'video') {
          this.playList = response.data.video;
          this.playList.map(video => {
            video.isSelected = false;
            video.thumb = (video.thumb != '') ? this.imagePath + video.thumb : '../../assets/images/icons/audio-primary-default-card-icon.jpg';
          })
        }
        if (this.editPlaylistObj) {
          this.getPlaylistSelected();
        } else {
          this._spinner.hide();
        }
      } else {
        this._spinner.hide();
      }
    }, (error: any) => {
      this.playList = [];
      this._spinner.hide();
      this.errorMessage = error;
      this.isError = true;
    });
    // }
  }

  playlistChange(data) {
    data.isSelected = !data.isSelected
    // this.playListSelectFlag = true;
    const filteredArray = this.playList.filter(val => {
      return val.isSelected;
    });
  }

  onSubmit() {
    this.submitted = true;
    if (!this.playlistName.valid) {
      return;
    }
    this._spinner.show();
    this.collectablesAttributes = [];
    this.SelectedPlaylistArray.forEach(element => {
      if (element.content_relationship) {
        this.collectablesAttributes.push({
          content_relationship_id: element.content_relationship.id
        });
      }
    })
    this.playListSelectFlag = true;
    let obj = {}
    if (this.data === 'audio') {
      obj = {
        content_collection:
        {
          name: this.playlistName.get('name').value,
          collection_type: "normal",
          collectables_attributes: this.collectablesAttributes
        }
      }
    }
    if (this.data === 'video') {
      obj = {
        content_collection: {
          name: this.playlistName.get('name').value,
          collection_type: "normal",
          collectables_attributes: this.collectablesAttributes
        }
      }
    }

    if (this.collectablesAttributes.length < 2) {
      this._spinner.hide();
      this.playListSelectFlag = true;
      this.isPlayListError = true;
      return;
    }
    if (this.editPlaylistObj && this.editPlaylistObj.id) {
      this._privateLibraryPackageService.editPackage(this.editPlaylistObj.id, obj).subscribe((response: any) => {
        this._spinner.hide();
        if (response.success) {
          this.activeModal.close(response.data.content_collection);
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.PLAYLIST_UPDATED_SUCCESS;
        } else {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.PLAYLIST_UPDATED_ERROR;
          this.errorMessage = response.message;
          this.isError = true;
        }
      }, (error: any) => {
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = error;
        // this._toastr.warning(error);
        this._spinner.hide();
        this.errorMessage = error;
        this.isError = true;
      });
    } else {
      this._playListService.createPlayList(obj).subscribe((response: any) => {
        this._spinner.hide();
        if (response.success) {
          this.playListData = response.data;
          this.activeModal.close('success');
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.PLAYLIST_CREATED_SUCCESS;
        } else {
          this.errorMessage = response.message;
          this.isError = true;
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
          // this._toastr.warning('Something Went Wrong');
        }
      }, (error: any) => {
        // this._toastr.warning(error);
        this._spinner.hide();
        this.errorMessage = error;
        this.isError = true;
      })
    }
  }

  // addAudioVideo() {
  //   if (this.flagAdd) {
  //     this.addVideos = this.videoDataPlaylist
  //     this.addVideos.map(val => {
  //       val.isSelected = false;
  //       val.thumb = (val.thumb != '') ? this.imagePath + val.thumb : '../../assets/images/icons/audio-primary-default-card-icon.jpg';
  //     })
  //     this.addSongs = this.musicDataPlaylist
  //     this.addSongs.map(val => {
  //       val.isSelected = false;
  //       val.thumb = (val.thumb != '') ? this.imagePath + val.thumb : '../../assets/images/icons/audio-primary-default-card-icon.jpg';
  //     })
  //   }
  // }

  playlistContentChange(data) {
    data.isSelected = !data.isSelected;

    if (data.isSelected) {
      this.SelectedPlaylistArray.push(data);
    } else {
      const index = this.SelectedPlaylistArray.findIndex(s => s.id === data.id);
      if (index > -1) {
        this.SelectedPlaylistArray.splice(index, 1);
      }
    }

    this.isAddContentPlaylist = false;
    this.isPlayListError = false;

  }

  getPlaylistSelected() {
    this._playListService.showPlayList(this.editPlaylistObj.id).subscribe((response: any) => {
      if (response.success) {
        this.selectedPlaylistAudio = response.data.content_collection;
        this.selectedPlaylistVideo = response.data.content_collection;
        if (this.selectedPlaylistAudio && this.selectedPlaylistAudio.contents && this.data == 'audio') {
          this.SelectedPlaylistArray = this.selectedPlaylistAudio.contents;
          this.selectedPlaylistAudio.contents.map(audio_contents => {
            audio_contents.thumb = (audio_contents.thumb != '') ? this.imagePath + audio_contents.thumb : '../../assets/images/icons/audio-primary-default-card-icon.jpg';
          });
        }

        if (this.selectedPlaylistVideo && this.selectedPlaylistVideo.contents && this.data == 'video') {
          this.SelectedPlaylistArray = this.selectedPlaylistVideo.contents;
          this.selectedPlaylistVideo.contents.map(video_contents => {
            video_contents.thumb = (video_contents.thumb != '') ? this.imagePath + video_contents.thumb : '../../assets/images/icons/audio-primary-default-card-icon.jpg';
          });
        }
        this.selectContent();
      }
      else {
        this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
        this.isError = true;
        this._spinner.hide();
      }
    }, (error: any) => {
      // this._toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
      this._spinner.hide();
      this.errorMessage = error;
      this.isError = true;
    })
  }

  selectContent() {
    if (this.data == 'audio') {
      this.playList.forEach(element => {
        if (this.selectedPlaylistAudio.contents.find(ele => { return ele.id === element.id })) {
          element.isSelected = true;
        } else {
          element.isSelected = false;
        }
      });
    } else {
      this.playList.forEach(element => {
        if (this.selectedPlaylistVideo.contents.find(ele => { return ele.id === element.id })) {
          element.isSelected = true;
        } else {
          element.isSelected = false;
        }
      });
    }
    this._spinner.hide();
  }


  addContentPlaylist() {
    this.submitted = true;
    if (!this.playlistName) {
      return;
    }
    // if (this.string === 'video') {
    //   const videos = this.addVideos.filter(val => {
    //     return val.isSelected;
    //   })
    //   videos.forEach((val) => {
    //     if (val.content_relationship) {
    //       const obj = {
    //         content_relationship_id: val.content_relationship.id
    //       }
    //       this.contentPlaylistSelect.push(obj);
    //     }
    //   })
    // }

    // if (this.string === 'audio') {
    //   const audios = this.addSongs.filter(val => {
    //     return val.isSelected;
    //   })
    //   audios.forEach((val) => {
    //     if (val.content_relationship) {
    //       const obj = {
    //         content_relationship_id: val.content_relationship.id
    //       }
    //       this.contentPlaylistSelect.push(obj);
    //     }
    //   })
    // }
    this.isAddContentPlaylist = false;
    this.contentPlaylistSelect = [];
    if (this.SelectedPlaylistArray.length) {
      this.SelectedPlaylistArray.forEach(element => {
        if (element.content_relationship) {
          this.contentPlaylistSelect.push({
            content_relationship_id: element.content_relationship.id
          });
        }
      })
    } else {
      this.isAddContentPlaylist = true;
      return;
    }
    const params =
    {
      content_collection:
      {
        collectables_attributes: this.contentPlaylistSelect
      }
    }
    this._playListService.addContentPlaylist(this.playlistToggleId, params).subscribe((response: any) => {
      if (response.success) {
        const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        modalRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.PLAYLIST_UPDATED_SUCCESS;
        this.activeModal.close('success');
      } else {
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.PLAYLIST_UPDATED_ERROR;
      }
    })
  }

  trimControl(control) {
    if (this.playlistName.get(control).value) {
      this.playlistName.get(control).setValue(this.playlistName.get(control).value.trim())
    }
  }

}
